export default{
  data() {
      return {
          apis: {
              byInst:'sh/wf/track/byInst',//根据实例主键获取流程轨迹
              byBiz:'sh/wf/track/byBiz',//根据业务主键流程轨迹
              tracks:'sh/wf/track/tracks'
          },
          constant:{
            TASK_TYPE_APPROVE: 1,//任务类型，审批任务
            TASK_TYPE_DUPLICATE: 2,//任务类型，抄送任务
            WF_TRACK_STATUS_APPLY: 1,/***任务状态：待审批*/
            WF_TRACK_STATUS_PASS: 2,/***任务状态：通过*/
            WF_TRACK_STATUS_REJECT: 3,/***任务状态：驳回*/
            WF_TRACK_STATUS_TURN: 4,/***任务状态：已转审*/
            WF_TRACK_STATUS_ABORTED: 5,/***任务状态：已撤销*/
            WF_TRACK_STATUS_CATCH_BACK: 6,/***任务状态：被抓回*/
            WF_TRACK_STATUS_RESTART: 7,/***任务状态：反办结*/
          },//
          tracks:[],//流程轨迹列表
          copyData:[],//抄送列表
          verdicts:['待审核', '通过', '驳回'],//处理结论
      }
  },
  props:{
      show:false,//是否显示轨迹抽屉
      instKey:null,//实例主键
      bizKey:null,//业务主键
  },
  watch: {
    bizKey() {
      this.loadTracks();
    },
    instKey() {
      this.loadTracks();
    },
  },
  mounted() { 
    this.loadTracks();
  },
  methods: {
      loadTracks(){
          const me = this;
          me.instKey ? me.byInst() : me.byBiz();
      },
      byInst(){//获取流程轨迹
          const me = this;
          me.tracks = [];
          if(!me.instKey){
              return;
          }
          me.$post({
            url:me.apis.byInst,
            params:me.instKey
          }).then(rsp=>{
            if(rsp.success){
              rsp.retList.forEach(item => { 
                if(item.status!=me.constant.WF_TRACK_STATUS_CATCH_BACK&&item.backed!=1){
                    me.tracks.push(item);
                  }
              }); 
            }
          });
      },
      byBiz(){
         this.loadTrackData();
         this.loadCopyData();
         
      },
      loadTrackData(){
         
        const me = this;
        me.tracks = [];
        if (!me.bizKey) {
          return;
        }
        me.$post({
          url: me.apis.tracks,
          params: {
            bizKey: me.bizKey,
            type:1
          }
        }).then(rsp => { 
          if (rsp.success) {
            rsp.retList.forEach(item => { 
              if(item.status!=me.constant.WF_TRACK_STATUS_CATCH_BACK&&item.backed!=1){
                me.tracks.push(item);
              }
            }); 
          }
        });
      },
    loadCopyData() {
      const me = this;
      me.copyData = [];
      if (!me.bizKey) {
        return;
      }
      me.$post({
        url: me.apis.tracks,
        params: {
          bizKey: me.bizKey,
          type: 2
        }
      }).then(rsp => {
        if (rsp.success) {
          me.copyData = rsp.retList;
        }
      });
    },
      toClose(){//发出关闭指令
        this.$emit('close', null, this);
      }
  },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/track/track_ver/src/track.js